import React, { Fragment } from 'react';
import type { Message } from '../App';
import { UserIcon } from 'lucide-react';
import { Logo } from './common/Logo';
interface ChatMessageProps {
  message: Message;
}
export const ChatMessage = ({
  message
}: ChatMessageProps) => {
  const isUser = message.role === 'user';
  const isThinking = message.role === 'assistant-thinking';
  const formatMessage = (text: string) => {
    // Split by newlines first
    return text.split('\n').map((line, i) => {
      // Replace bold markdown with spans
      const parts = line.split(/(\*\*.*?\*\*)/g);
      return <Fragment key={i} data-id="element-69">
          {parts.map((part, j) => {
          if (part.startsWith('**') && part.endsWith('**')) {
            return <span key={j} className="font-bold" data-id="element-70">
                  {part.slice(2, -2)}
                </span>;
          }
          return part;
        })}
          {i < text.split('\n').length - 1 && <br data-id="element-71" />}
        </Fragment>;
    });
  };
  return <div className={`flex gap-6 mb-12 w-full ${isUser ? 'flex-row-reverse' : ''}`} data-id="element-72">
      <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${isUser ? 'bg-[#4a90e2] text-white shadow-sm' : isThinking ? 'bg-[#2d2d2d] text-[#888888]' : 'text-white'}`} data-id="element-73">
        {isUser ? <UserIcon size={20} data-id="element-74" /> : <Logo size={32} data-id="element-75" />}
      </div>
      <div className={`flex flex-col ${isUser ? 'items-end' : 'items-start'} flex-grow max-w-[80%]`} data-id="element-76">
        <div className={`px-6 py-4 rounded-2xl w-full ${isUser ? 'bg-[#151A22]/60 text-[#e0e0e0] border border-white/5' : isThinking ? 'bg-command-rail border border-command-border-soft text-command-text-muted' : 'bg-[#26384F] border border-[#4F78B8] text-white shadow-lg shadow-[#4F78B8]/10'}`} data-id="element-77">
          <p className={`whitespace-pre-wrap leading-relaxed ${isThinking ? 'font-mono text-sm' : 'font-medium text-lg'}`} data-id="element-78">
            {formatMessage(message.content)}
          </p>
        </div>
        <span className="text-xs text-[#888888] mt-2 px-2" data-id="element-79">
          {new Date(message.timestamp).toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })}
        </span>
      </div>
    </div>;
};